import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardcommonComponent } from './dashboardcommon/dashboardcommon.component';
import { DashboardsubmenuComponent } from './dashboardsubmenu/dashboardsubmenu.component';
import { ForgotpasswordComponent } from './auth/forgotpassword/forgotpassword.component';
import { AuthguardGuard } from './guard/authguard.guard';
import { UserLoginComponent } from './auth/login/user-login.component';
import { LoginComponent } from './login/login.component';
import { ProfileComponent } from './profile/profile.component';
import { UsermanualComponent } from './usermanual/usermanual.component';
import { CommonContainerComponent } from './layout/common-layout/common-container/common-container.component';
// import { UsermasterComponent } from './users/usermaster/usermaster.component';
import { WebsiteContainerComponent } from './layout/website-layout/website-container/website-container.component';
import { HomeComponent } from './website/home/home.component';
import { UserContainerComponent } from './layout/user-layout/user-container/user-container.component';
import { UserAuthguardGuard } from './guard/user_authguard.guard';


const routes: Routes = [

  { path: 'online-services/login', component: UserLoginComponent },
  { path: 'auth/login', component: LoginComponent },
  { path: 'auth/forgotpassword', component: ForgotpasswordComponent },
  {
    path: 'accomodation', component: CommonContainerComponent, children: [
      { path: 'booking', loadChildren: () => import('./booking/booking.module').then(b => b.BookingModule) }
    ]
  },
  {
    path: 'donation', component: CommonContainerComponent, children: [
      { path: 'donateform', loadChildren: () => import('./donation/donation.module').then(d => d.DonationModule) }
    ]
  },
  {
    path: 'package', component: CommonContainerComponent, children: [
      { path: 'packagebooking', loadChildren: () => import('./Package/Package.module').then(d => d.PackageModule) }
    ]
  },
  {
    path: 'v', component: DashboardcommonComponent, children: [
      {
        path: 'admin',
        // canActivate: [AuthguardGuard], 
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminmoduleModule)
      }

      ,
      {
        path: 'transaction',
        canActivate: [AuthguardGuard],
        loadChildren: () => import('./transaction/transaction.module').then(m => m.TransactionModule)
      }
      ,
      { path: 'dynamicpages', loadChildren: () => import('./dynamicpages/dynamicpages.module').then(m => m.DynamicpagesModule) }
      ,
      { path: 'dashboard/home', component: DashboardComponent },
      { path: 'dynamicpages', loadChildren: () => import('./dynamicpages/dynamicpages.module').then(m => m.DynamicpagesModule) }
      ,
      { path: 'dashboard/home', component: DashboardComponent },
      // {path:'master/users',component:UsermasterComponent},
      { path: 'dashboard/modules/:id', component: DashboardsubmenuComponent },

      { path: 'changepassword', component: ChangepasswordComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'user-manual', component: UsermanualComponent },


    ]
  },
  {
    path: 'user', component: UserContainerComponent, children: [
      { path: '', canActivate: [UserAuthguardGuard], loadChildren: () => import('./user/user.module').then(m => m.UserModule) }
    ]
  },
  {
    path: '', component: WebsiteContainerComponent, children: [
      { path: '', component: HomeComponent },
      {
        path: 'home-page',
        // canActivate: [AuthguardGuard], 
        loadChildren: () => import('./website/website.module').then(m => m.WebsiteModule)
      }
    ]
  },
  { path: '**', redirectTo: '/home-page', pathMatch: 'full' }



];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
